export default __webpack_public_path__ + "57a41dc270f74ff99182beda042879bc.ico";